import {FC, useState} from 'react';
import {create, InstanceProps} from 'react-modal-promise';
import {Button, DialogActions, DialogContent} from '@mui/material';

import {
  BASKETBALL_QUARTER_MINUTES,
  BasketballQuarterMinutes,
} from '@entities/basketball';
import {Dialog, DialogTitle, Select, SelectValue} from '@shared/components';

interface DialogProps {
  leagueName: string;
  quarterMinutes: number;
}

type Props = InstanceProps<BasketballQuarterMinutes> & DialogProps;

const OPTIONS = BASKETBALL_QUARTER_MINUTES.map(value => ({
  value,
  label: `${value} min`,
}));

const EditQuarterMinutesDialog: FC<Props> = ({
  onReject,
  onResolve,
  leagueName,
  quarterMinutes,
}) => {
  const [value, setValue] = useState<SelectValue>(quarterMinutes);

  const handleSave = () => {
    onResolve(value as BasketballQuarterMinutes);
  };

  return (
    <Dialog
      onClose={() => {
        onReject();
      }}
      open={true}
    >
      <DialogTitle
        title={`Quarter minutes — ${leagueName}`}
        onClose={() => {
          onReject();
        }}
      />

      <DialogContent
        sx={{minWidth: 300, paddingTop: '30px !important', paddingBottom: 2}}
      >
        <Select
          label="Quarter minutes"
          options={OPTIONS}
          value={value}
          onChange={setValue}
        />
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            onReject();
          }}
        >
          Cancel
        </Button>

        <Button fullWidth onClick={handleSave} disabled={!value}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const openEditQuarterMinutesDialog = create<
  Props,
  BasketballQuarterMinutes
>(EditQuarterMinutesDialog);
